import Cookies from 'js-cookie'
import { getAppVersionInfo, addAppVersionInfo, deleteAppVersionInfo } from '@/api/app'

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false
    },
    device: 'desktop',
    total: 0,
    rows: [],
    row: {}
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    SET_TOTAL: (state, total) => {
      state.total = total
    },
    SET_ROWS: (state, rows) => {
      state.rows = rows
    },
    SET_ROW: (state, row) => {
      state.row = row
    }
  },
  actions: {
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    CloseSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    // 获取App版本信息
    GetAppVersionInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        getAppVersionInfo(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 添加App版本信息
    AddAppVersionInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        addAppVersionInfo(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除App版本信息
    DeleteAppVersionInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteAppVersionInfo(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js